import { observable } from "mobx";

export class ScaledImageCoordinates {
    @observable
    public width: number;
    @observable
    public height: number;

    @observable
    public originalWidth: number;
    @observable
    public originalHeight: number;

    constructor(
        width: number,
        height: number,
        originalWidth: number,
        originalHeight: number,
    ) {
        this.width = width;
        this.height = height;
        this.originalWidth = originalWidth;
        this.originalHeight = originalHeight;
    }

    public onImageSize = (width: number, height: number) => {
        this.originalWidth = width;
        this.originalHeight = height;
    };

    public onResize = (width: number, height: number) => {
        this.width = width;
        this.height = height;
    };

    public get scale(): number {
        if (!this.originalWidth || !this.originalHeight) {
            return 0;
        }
        return Math.min(
            this.width / this.originalWidth,
            this.height / this.originalHeight,
        );
    }

    public project(x: number, y: number): [number, number] {
        if (!this.scale) {
            return [0, 0];
        }
        return [
            (x - this.originalWidth / 2) * this.scale + this.width / 2,
            (y - this.originalHeight / 2) * this.scale + this.height / 2,
        ];
    }

    public unproject(x: number, y: number): [number, number] {
        if (!this.scale) {
            return [0, 0];
        }
        return [
            (x - this.width / 2) / this.scale + this.originalWidth / 2,
            (y - this.height / 2) / this.scale + this.originalHeight / 2,
        ];
    }

    public scaleDimensions(width: number, height: number) {
        return [width * this.scale, height * this.scale];
    }

    public unscaleDimensions(width: number, height: number) {
        return [width / this.scale, height / this.scale];
    }

    public scaleBox = ({
        x,
        y,
        width,
        height,
    }: {
        x: number;
        y: number;
        width: number;
        height: number;
    }) => {
        if (!this.scale) {
            return undefined;
        }

        const [scaledX, scaledY] = this.project(x, y);
        const [scaledWidth, scaledHeight] = this.scaleDimensions(width, height);

        return {
            x: scaledX,
            y: scaledY,
            width: scaledWidth,
            height: scaledHeight,
        };
    };
}
